<template>
  <div class="about">Thanks</div>
</template>

<script>
export default {
  data: function () {
    return {};
  },
  props: {
    code: String,
  },
  mounted() {
    this.getToken();
  },
  methods: {
    async getToken() {
      const request = new Request(
        this.$apihost + "/onebeerleft.OneBeerLeftService/GetToken",
        {
          method: "POST",
          mode: "cors",
          cache: "default",
          body: JSON.stringify({
            code: this.code,
          }),
        }
      );
      var res = await fetch(request);
      var data = await res.json();
      console.log("RESPONSE: " + JSON.stringify(data));
      this.$cookie.set("onebeerleft-login", data.cookieToken, {
        expires: "1Y",
      });
      this.$store.commit("login");
      this.$router.push("/");
    },
  },
};
</script>
